import React from 'react';
import { ToroLearnIcon } from '../icon';

import './styles.scss';

interface IResourceCardProps {
 src: string;
 name: string;
}

export const ToroLearnResourceCard = ({ src, name }: IResourceCardProps): JSX.Element => {

    const extension = (src.split('.').pop() || 'desconhecido').toUpperCase();

    return (
        <div className="card card-resource w-100 shadow border-0">
            <div className="card-body rounded-lg px-4 py-3">
                <div className="card-content row justify-content-center align-items-center">
                    <div className="col-3">
                        <ToroLearnIcon icon="paper" size={32} fill="#7E868E" />
                    </div>
                    <div className="col-9">
                        <h6 className="text-capitalize mb-1 font-size-8">{name}</h6>
                        <p className="m-0 small text-gray-dark font-weight-light font-size-9">Arquivo {extension}</p>
                        <a
                            href={src}
                            rel="noreferrer"
                            target="_blank"
                            className="p-0 pt-2 btn btn-sm btn-link text-secondary text-uppercase font-weight-bold">
                            <span className="font-size-9 pt-4">
                                    Fazer download
                            </span>
                            <span style={{ position: 'relative', top: -2 }}>
                                <ToroLearnIcon icon="upload-arrow" size={12} fill="#E7517E" className="icon-rotate"/>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
